// check if name string just contains space if yes return fallback translation
export function getNonEmptyStringOrFallback(s: string | undefined, fallback: string): string {
  const nameOnlySpaces = !s?.replace(/\s/g, '').length
  if (s === undefined || nameOnlySpaces) {
    return fallback
  }

  return s
}

const DISPLAY_LABEL_SANITIZE_REGEX = /(--|;|'|"|\/\*|\*\/)/g

export function sanitizeDisplayLabel(value: string): string {
  return value.replace(DISPLAY_LABEL_SANITIZE_REGEX, '').trim()
}
